'use client';

import { useTranslations } from 'next-intl';
import { ContentHeader, TabBar } from '../../components';
import { ContentWidthWrapper } from '../../components/content-width-wrapper';
import { Column } from '../../styles';
import { ImprintScreen } from '../imprint/ImprintScreen';
import { PrivacyScreen } from '../privacy/PrivacyScreen';
import ContactScreen from '../contact/ContactScreen';
import FAQScreen from '../faq/FAQScreen';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { AboutScreen } from '../about/AboutScreen';

enum ServiceTab {
    Contact = 'contact',
    FAQs = 'faq',
    About = 'about',
    Imprint = 'imprint',
    Privacy = 'privacy'
}

const ServiceScreen = () => {
    const t = useTranslations('service');
    const router = useRouter();
    const searchParams = useSearchParams();
    const pathname = usePathname();
    const tab = searchParams.get('tab');

    const getTabIndex = () => {
        switch (tab) {
            case ServiceTab.Contact:
                return 0;
            case ServiceTab.FAQs:
                return 1;
            case ServiceTab.About:
                return 2;
            case ServiceTab.Imprint:
                return 3;
            case ServiceTab.Privacy:
                return 4;
            default:
                return 0;
        }
    };

    const getTabParam = (tabIndex: number) => {
        switch (tabIndex) {
            case 0:
                return ServiceTab.Contact;
            case 1:
                return ServiceTab.FAQs;
            case 2:
                return ServiceTab.About;
            case 3:
                return ServiceTab.Imprint;
            case 4:
                return ServiceTab.Privacy;
            default:
                return ServiceTab.Contact;
        }
    };

    const onSwitchTab = (tabIndex: number) =>
        router.push(pathname + `?tab=${getTabParam(tabIndex)}`);

    return (
        <ContentWidthWrapper variant='medium'>
            <Column gap={3}>
                <ContentHeader
                    title={t('title')}
                    description={t('description')}
                    px={3}
                    pt={5}
                />
                <TabBar
                    sx={{ px: 3 }}
                    tabHeadlines={[
                        t('tabs.contact'),
                        t('tabs.faq'),
                        t('tabs.about'),
                        t('tabs.imprint'),
                        t('tabs.privacy')
                    ]}
                    tabContents={[
                        <ContactScreen key='contact' />,
                        <FAQScreen key='faq' />,
                        <AboutScreen key='about' />,
                        <ImprintScreen key='imprint' />,
                        <PrivacyScreen key='privacy' />
                    ]}
                    preopenedTab={getTabIndex()}
                    onSwitchTab={onSwitchTab}
                />
            </Column>
        </ContentWidthWrapper>
    );
};

export default ServiceScreen;
